const TRUE_VALUES = new Set([
  true,
  1,
  '1',
  'true',
  'verified',
  'confirmed',
  'yes',
  'emailverified',
  'email_verified',
]);

const FALSE_VALUES = new Set([
  false,
  0,
  '0',
  'false',
  'unverified',
  'pending',
  'notverified',
  'not_verified',
  'unconfirmed',
  'no',
]);

function normalizeToken(value) {
  if (typeof value === 'boolean' || typeof value === 'number') {
    return value;
  }
  if (typeof value === 'string') {
    return value.trim().toLowerCase().replace(/\s+/g, '');
  }
  return value;
}

/**
 * Parse backend / profile boolean-like verification values.
 * @returns {true|false|null} null when value is missing or unrecognized
 */
export function parseBooleanLike(value) {
  if (value == null || value === '') return null;

  const normalized = normalizeToken(value);

  if (TRUE_VALUES.has(normalized)) return true;
  if (FALSE_VALUES.has(normalized)) return false;

  return null;
}

/**
 * Resolve email verification from user profile fields.
 * Goat primary field: emailVerificationStatus.
 * Does not use signup captcha "Verified" UI state.
 * Does not fall back to CDK default (which may be true before session hydrate).
 * @returns {true|false|null}
 */
export function getEmailVerificationStatus(user) {
  if (!user) return null;

  const candidates = [
    user.emailVerificationStatus,
    user.emailVerified,
    user.email_verified,
    user.EmailConfirmed,
    user.emailConfirmed,
    user.isEmailVerified,
    user.IsEmailVerified,
  ];

  for (const candidate of candidates) {
    const parsed = parseBooleanLike(candidate);
    if (parsed !== null) return parsed;
  }

  return null;
}

/** Coupon promo cashier may open only when status is reliably verified. */
export function isEmailVerifiedForCoupon(user) {
  return getEmailVerificationStatus(user) === true;
}
